import { apiRoutes } from 'lib/@getethos/urls/apiRoutes'
import { setAndGetUserUuid } from 'lib/FeaturesAndExperiments/setAndGetUserUUID'

export const sendToAnalyticsService = (
  event: string,
  properties: Record<string, any>
) => {
  const anonymousId = setAndGetUserUuid()

  apiRoutes.sendAnalyticsEvent({
    event: event,
    anonymousId: anonymousId,
    properties: properties,
  })
}
